// extracted by mini-css-extract-plugin
module.exports = {"info":"_19S0T7cbijww4HBZXwWLgG"};